import { Text, View } from "@react-pdf/renderer";

export const AvailableOfficialsList = ({ availableOfficials, intl }) => (
  <View
    style={{
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      flexWrap: "wrap",
    }}
  >
    {Object.keys(availableOfficials).map((key, index) => (
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          fontFamily: ["Noto Sans", "Noto Sans TC"],
          marginRight: 8,
        }}
        key={`available-official-role-${index}`}
      >
        <Text style={{ fontWeight: "bold", fontSize: 7.7 }}>
          {intl.formatMessage({
            id: `reports.role.${key.toLowerCase()}`,
            defaultMessage: "Official role",
          })}
          :{" "}
        </Text>
        {availableOfficials[key].map((person, idx) => (
          <Text style={{ fontSize: 7.7 }} key={`available-official-${idx}`}>
            {person.name}
            {idx + 1 === availableOfficials[key].length ? "; " : ", "}
          </Text>
        ))}
      </View>
    ))}
  </View>
);
